<div class="flex flex-col h-full justify-between">
  <div>
    <div class="pb-md mb-4xl">
      <p class="text-xl text-neutral-900 font-semibold">
        {{ 'edit_system_settings_screen_edit_work_info_label' | transloco }}
      </p>
    </div>
    <div class="py-sm border-b border-neutral-200">
      <p class="text-neutral-900 font-semibold text-lg py-lg">
        {{ 'system_settings_screen_working_days_label' | transloco }}
      </p>
    </div>
    <form [formGroup]="form">
      <p class="text-neutral-900 font-medium text-sm mt-lg label-required">
        {{ 'system_settings_screen_working_days_label' | transloco }}
      </p>
      <div class="grid-container my-lg">
        @for (day of this.workingDays()?.days; track day.name.value) {
          <div class="flex gap-md">
            <lib-checkbox
              width="1rem"
              height="1rem"
              iconWidth="0.7125rem"
              iconHeight="0.525rem"
              [hasMarginEnd]="false"
              [formGroup]="getDayFormGroup(day.name.value)"
              [inputFormControlName]="'is_working'"
              [singleCheckBox]="true"
              [id]="day.name.value"
              (checkboxValueChange)="checkStartDayIncludedInWorkingDays()"
              class="flex items-center justify-center" />
            <p class="text-base font-medium text-neutral-900">
              {{ day.name.label }}
            </p>
          </div>
        }
      </div>
      <div class="w-25">
        <lib-select
          [inputFormControlName]="'start_day'"
          id="start_day"
          name="start_day"
          [label]="
            'edit_system_settings_screen_week_start_on_label' | transloco
          "
          [placeholder]="
            'edit_system_settings_screen_week_start_on_label' | transloco
          "
          [options]="returnSelectedWorkingDays()"
          [selectedKeyValue]="'value'"
          [selectedKeyName]="'label'"
          [required]="true" />
        @if (
          form.get('start_day')?.invalid &&
          (form.get('start_day')?.touched || form.get('start_day')?.dirty)
        ) {
          <div class="text-destructive-500 text-sm font-normal mt-sm">
            {{
              'edit_system_settings_validation_message_required_label'
                | transloco
            }}
          </div>
        }
      </div>
      <div class="mt-2xl mb-lg py-lg border-b border-neutral-200">
        <p class="text-neutral-900 font-semibold text-lg py-lg">
          {{ 'system_settings_screen_working_hours_label' | transloco }}
        </p>
      </div>
      <div class="flex gap-lg">
        <div class="w-25">
          <lib-select
            [inputFormControlName]="'started_at'"
            id="started_at"
            name="started_at"
            [label]="
              'edit_system_settings_screen_start_at_label'
                | transloco
                  : { timezone: 'GMT', offset: currentTimezoneOffsetHours }
            "
            [placeholder]="
              'edit_system_settings_screen_start_at_label'
                | transloco
                  : { timezone: 'GMT', offset: currentTimezoneOffsetHours }
            "
            [options]="dropdownTimeOptions"
            [selectedKeyValue]="'value'"
            [selectedKeyName]="'label'"
            [required]="true" />
        </div>
        <div class="w-25">
          <lib-select
            [inputFormControlName]="'ended_at'"
            id="ended_at"
            name="ended_at"
            [label]="
              'edit_system_settings_screen_end_at_label'
                | transloco
                  : { timezone: 'GMT', offset: currentTimezoneOffsetHours }
            "
            [placeholder]="
              'edit_system_settings_screen_end_at_label'
                | transloco
                  : { timezone: 'GMT', offset: currentTimezoneOffsetHours }
            "
            [options]="dropdownTimeOptions"
            [selectedKeyValue]="'value'"
            [selectedKeyName]="'label'"
            [required]="true" />
          @if (form.get('ended_at')?.invalid && form.get('ended_at')?.touched) {
            <div class="text-destructive-500 text-sm font-normal mt-sm">
              {{
                'edit_system_settings_validation_time_range_error' | transloco
              }}
            </div>
          }
        </div>
      </div>
    </form>
  </div>

  <div class="flex justify-end gap-lg mt-2xl">
    <a
      id="cancel"
      class="px-2xl py-sm rounded-md text-neutral-700 bg-white text-lg font-medium cursor-pointer"
      [routerLink]="[
        `/${ADMIN_ROUTES.SYSTEM_SETTINGS.PROFILE}/view` | tenantPath: 'admin',
      ]">
      {{ 'edit_system_settings_screen_discard_button_label' | transloco }}
    </a>

    <button
      id="submit"
      class="bg-primary-500 px-2xl py-sm rounded-md text-white text-base cursor-pointer"
      (click)="submit()"
      [class.opacity-30]="isLoading()"
      [disabled]="isLoading()">
      {{ 'edit_system_settings_screen_save_button_label' | transloco }}
    </button>
  </div>
</div>
